import React, { useContext, useEffect, useState } from 'react';
import "../Styles/TATTimelineCss.css";
import { useTranslation } from 'react-i18next';
import Download from '../../../../components/SVGComponents/Download';
import CheckCircle from '../../../../components/SVGComponents/CheckCircle';
import TimeQuery from '../../../../components/SVGComponents/TimeQuery';
import RowBadge from '../Badge/RowBadge';
import Moment from "moment";
import themeContext from '../../../../context/theme/ThemeContext';
import { USERTYPES } from '../../../../constants/Constants';
import userContext from '../../../../context/users/UserContext';

const TATTimelineBody = (props) => {
    const [t] = useTranslation();
    const { getThemeColor,getAlterColor } = useContext(themeContext);
    const studyData = props.studyCloseData;
    const [showEstimatedTimeEnabled, setShowEstimatedTimeEnabled] = useState(true);
    const { roles} = useContext(userContext);

    const getClosedStatus = () => {
      if(studyData?.closed != null && studyData?.closed != undefined && studyData?.closed){
        return true;
      }
      return false;
    }

    useEffect(() =>{
      if(process.env.REACT_APP_VDC_PLATFORM === "true" && roles[0] == USERTYPES.RADIOLOGIST){
        setShowEstimatedTimeEnabled(false);
      }
    }, [])

    const getActiveClassName = (data,index) => {
      //(idx == 0 ? data.active? 'active-timeline-line-first':'timeline-line-first' ? 'active-timeline-line' : 'timeline-line':''
      if(index == 0){
        if(data.active){
          return 'active-timeline-line-first';
        }else{
          return getClosedStatus()?'timeline-line-first closed-timeline-line':'timeline-line-first';
        }
      }else if(index == props.timelineStatus?.length-1){
        if(data.active){
          return 'active-timeline-line-last';
        }else{
          return getClosedStatus()?'timeline-line-last closed-timeline-line':'timeline-line-last';
        }
      }else{
        if(data.active){
          return 'active-timeline-line';
        }else{
          return getClosedStatus()?'timeline-line closed-timeline-line':'timeline-line';
        }
      }
    }

    function formatMinutes(minutes) {
      if (minutes === "NA") return minutes;
      
      let negative = false;
      if (minutes.startsWith("-")) {
        negative = true;
        minutes = minutes.substring(1);
      }
    
      const duration = Moment.duration(minutes, 'minutes');

    // Get the components
    const years = duration.years();
    const months = duration.months();
    const days = duration.days();
    const hours = duration.hours();
    const minutesVar = duration.minutes();
    const seconds = duration.seconds();
    let formattedTime = "";

    // if(seconds > 0){
    //   formattedTime = `${years}Y : ${months}M : ${days}D : ${hours}H : ${minutesVar}M : ${seconds}S`;
    // }else{
    //   formattedTime = `${years}Y : ${months}M : ${days}D : ${hours}H : ${minutesVar}M`;
    // }

    switch(true){
      case years > 0:
        formattedTime = `${years}-Years, ${months}-Months, ${days}-Days, ${hours}-Hours, ${minutesVar}-Minutes`;
        break;
      
      case months > 0:
        formattedTime = `${months}-Months, ${days}-Days, ${hours}-Hours, ${minutesVar}-Minutes`;
        break;

      case days > 0:
        formattedTime = `${days}-Days, ${hours}-Hours, ${minutesVar}-Minutes`;
          break;

      case hours > 0:
        formattedTime = `${hours}-Hours, ${minutesVar}-Minutes`;
        break;

      case minutesVar > 0:
        formattedTime = `${minutesVar}-Minutes`;
        break;
      
      case seconds > 0:
       

      default:
        break;
    }
    
    if(seconds > 0){
      formattedTime = `,${seconds}-Seconds`
    }
    
      return negative ? "(Delayed) " + formattedTime : formattedTime;
    }

    const getFormatedDate = (date) => {
      var currentDate = Moment(date).local().format("DD-MMM-YY HH:mm:ss");
      return currentDate;
    };


  return (
    <div className="tat-timeline-container">
      {(showEstimatedTimeEnabled && studyData?.closed != true && props.data.reportDoneStatus != null && props.data.reportDoneStatus != null && props.data.reportDoneStatus != 2) && <div className="estimated-div">
        <p className='estimated-time'>{t("tat-timeline.estimated-time-for-report")}: <span>{props.estimateTime}&nbsp;mins</span></p>
      </div>}
      {
        studyData?.closed == true && <div className="estimated-div">
          <p className='estimated-time' style={{color:"red"}}>{t("tat-timeline.closed-study")}: <span style={{color:"white"}}>{studyData?.closedReason}</span></p>
        </div>
      }
      
      <div className="timeline-container">
          {props.timelineStatus.map((data, idx) => (
            <div key={idx} className={getActiveClassName(data,idx)}>
              <div className="timeline-item" style={{width:process.env.REACT_APP_HYBRID_MODE == "false" ? "48%":"44%"}}>
                {(idx != 0 && data.diff != "NA" && data.diff != "" && data.diff?.length > 0) && <div style={{color:getAlterColor("#C1C1C1","rgb(75 75 75)")}} className='time-difference-container'> 
                <span style={{color: getThemeColor("primary-color")}} className='time-difference-text'>
                {/* <RowBadge tooltipText="Elapsed Time" name="ET" /> */}
                
                {t("label.elapse-time")}:&nbsp;
                </span> {formatMinutes(data.diff)}
                  </div>}
                <div style={{color: getThemeColor("primary-color")}} className="timeline-item-content">                    
                    <p className='timeline-item-content-p'>{data.name}</p>
                    <span className='circle' style={{backgroundColor:getAlterColor("#191919","#FFF"),zIndex:1000}}>
                      {data.active ? <CheckCircle /> : <TimeQuery closed = {getClosedStatus()}/> }
                    </span>
                </div>
                <div className='timeline-item-time'>
                { (data.time != null && data.time != undefined && data.time != "NA" && data.time != "") &&<time style={{whiteSpace:'nowrap',color:getAlterColor("#DFDFDF","#000")}}>{getFormatedDate(data.time)}</time>}
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  )};

export default TATTimelineBody